(() => {
  const PLACED_CLASS = 'stock-alert-button--placed';
  const UNIT_CLASS = 'stock-alert-unit';
  const STOCK_ALERT_SELECTOR = '.rez-stock-notification-button, [class*="rez-out-of-stock"]';
  const REZ_WRAPPER_SELECTOR = '.rez-button-wrapper';
  const REZ_MODAL_SELECTOR = '.rez-notify-modal';
  const PRODUCT_ROOT_SELECTOR = 'product-info, .product__info-container, [id^="MainProduct"]';
  const SOLD_OUT_QUICK_ADD_SELECTOR = '[data-sold-out-message="true"], .quick-add__submit[disabled]';
  const SPINNER_SELECTOR = '.stock-alert-button-loading';
  const STOCK_ALERT_TEXT = /get back in stock|back in stock alert|notify me when back/i;

  function isExcludedControl(element) {
    if (element.matches(`.product-form__submit, .cart-submit-button, .card__quick-add-icon, .special-order-button, [data-special-order-button], .quantity__button, ${REZ_WRAPPER_SELECTOR}`)) return true;
    return Boolean(element.closest(`.quantity, .shopify-payment-button, .product-form__sold-out-label, ${REZ_MODAL_SELECTOR}`));
  }

  function isStockAlertButton(element) {
    if (!element || isExcludedControl(element)) return false;
    return element.matches(STOCK_ALERT_SELECTOR);
  }

  function isStockAlertByText(element) {
    if (!element || isExcludedControl(element)) return false;
    const text = element.textContent.replace(/\s+/g, ' ').trim();
    return STOCK_ALERT_TEXT.test(text);
  }

  function alertUnitFor(button) {
    let unit = button;
    let wrapper = button.parentElement?.closest(REZ_WRAPPER_SELECTOR);
    while (wrapper) {
      unit = wrapper;
      wrapper = wrapper.parentElement?.closest(REZ_WRAPPER_SELECTOR);
    }
    return unit;
  }

  function styleStockAlertButton(button) {
    button.classList.add(PLACED_CLASS);
    button.setAttribute('aria-label', 'Notify me when back in stock');
    button.style.setProperty('background-color', '#ca8a04', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', '0', 'important');
    button.style.setProperty('box-shadow', 'none', 'important');
    button.style.setProperty('font-size', '0', 'important');
    button.querySelectorAll('button, a, span, div').forEach((child) => {
      child.style.setProperty('background', 'transparent', 'important');
      child.style.setProperty('background-color', 'transparent', 'important');
      child.style.setProperty('color', 'transparent', 'important');
      child.style.setProperty('font-size', '0', 'important');
      child.style.setProperty('border', '0', 'important');
    });
  }

  function syncProductRows(root = document) {
    const rows = root.matches?.('.product-form__buttons') ? [root] : root.querySelectorAll('.product-form__buttons');
    rows.forEach((row) => {
      const submit = row.querySelector('.product-form__submit');
      if (!submit) return;
      const soldOut = submit.disabled;
      row.classList.toggle('product-form__buttons--sold-out', soldOut);

      const label = row.querySelector('.product-form__sold-out-label');
      const text = submit.querySelector('span')?.textContent.replace(/\s+/g, ' ').trim();
      if (label && soldOut && text) label.textContent = text;

      const hasUnit = Boolean(row.querySelector(`:scope > .${UNIT_CLASS}`));
      row.classList.toggle('product-form__buttons--has-stock-alert', soldOut && hasUnit && !row.closest('[data-special-order]'));
    });
  }

  function hideSpinners(container) {
    if (!container) return;
    container.querySelectorAll(SPINNER_SELECTOR).forEach((spinner) => spinner.remove());
  }

  function createSpinner(compact = false) {
    const templateId = compact ? 'stock-alert-button-spinner-tpl-compact' : 'stock-alert-button-spinner-tpl';
    const template = document.getElementById(templateId);
    if (!template) return null;
    return template.content.firstElementChild?.cloneNode(true) || null;
  }

  function insertSpinnerAfter(anchor, compact = false) {
    if (!anchor || anchor.parentElement?.querySelector(SPINNER_SELECTOR)) return;
    const spinner = createSpinner(compact);
    if (spinner) anchor.insertAdjacentElement('afterend', spinner);
  }

  function isCardSoldOut(card) {
    if (card.dataset.soldOut === 'true') return true;
    return Boolean(
      card.querySelector('.card__price-row--inline-quick-add') &&
        !card.querySelector('.quick-add__submit:not([disabled])')
    );
  }

  function ensureCardSpinner(card) {
    if (!isCardSoldOut(card)) {
      hideSpinners(card);
      return;
    }

    if (card.querySelector(`${STOCK_ALERT_SELECTOR}.${PLACED_CLASS}`)) {
      hideSpinners(card);
      return;
    }

    const slot = card.querySelector('.card__price-row__quick-add, .card__price-row--inline-quick-add, .card__price-row');
    if (!slot || slot.querySelector(SPINNER_SELECTOR)) return;

    const spinner = createSpinner(true);
    if (spinner) slot.appendChild(spinner);
  }

  function ensureProductPageSpinner(container = document) {
    if (!document.body.classList.contains('template-product')) return;

    container.querySelectorAll(PRODUCT_ROOT_SELECTOR).forEach((root) => {
      if (root.hasAttribute('data-special-order') || root.closest('[data-special-order]')) {
        hideSpinners(root);
        return;
      }
      const buttonsRow = root.querySelector('.product-form__buttons');
      if (!buttonsRow) return;

      const submitButton = buttonsRow.querySelector('.product-form__submit');
      const hasPlacedButton = Boolean(buttonsRow.querySelector(`:scope > .${UNIT_CLASS}`));

      if (!submitButton || !submitButton.disabled || hasPlacedButton) {
        hideSpinners(buttonsRow);
        return;
      }

      insertSpinnerAfter(submitButton, false);
    });
  }

  function placeProductStockAlertButton(button) {
    if (!button || isExcludedControl(button)) return;

    const unit = alertUnitFor(button);
    const buttonsRow =
      unit.closest('.product-form__buttons') ||
      unit.closest('product-form, .product-form')?.querySelector('.product-form__buttons') ||
      unit.closest(PRODUCT_ROOT_SELECTOR)?.querySelector('product-form .product-form__buttons');

    if (!buttonsRow) return;

    const existing = buttonsRow.querySelector(`:scope > .${UNIT_CLASS}`);
    if (existing && existing !== unit) {
      unit.hidden = true;
      unit.style.setProperty('display', 'none', 'important');
      return;
    }

    styleStockAlertButton(button);
    unit.classList.add(UNIT_CLASS);
    hideSpinners(buttonsRow);

    const submitButton = buttonsRow.querySelector(':scope > .product-form__submit');
    if (submitButton) {
      if (unit.parentElement !== buttonsRow || unit.previousElementSibling !== submitButton) {
        submitButton.insertAdjacentElement('afterend', unit);
      }
    } else if (unit.parentElement !== buttonsRow) {
      buttonsRow.appendChild(unit);
    }

    syncProductRows(buttonsRow);
  }

  function hideSoldOutQuickAdd(slot) {
    slot.querySelectorAll(SOLD_OUT_QUICK_ADD_SELECTOR).forEach((control) => {
      const wrapper = control.closest('.quick-button--add');
      (wrapper || control).hidden = true;
    });
  }

  function triggerRezCollectionProcess() {
    const manager = window.REZ_COLLECTION_INSTANCES?.outOfStockManager;
    if (typeof manager?.processCollectionPage === 'function') {
      manager.processCollectionPage();
    }
  }

  let rezProcessTimer;

  function scheduleRezCollectionProcess() {
    if (!isSearchPage()) return;
    window.clearTimeout(rezProcessTimer);
    rezProcessTimer = window.setTimeout(triggerRezCollectionProcess, 150);
  }

  function isSearchPage() {
    return (
      document.body.classList.contains('template-search') ||
      window.location.pathname.replace(/^\/[a-z]{2}(?=\/|$)/i, '').includes('/search')
    );
  }

  function findCardStockAlertButton(card) {
    const button = card.querySelector(STOCK_ALERT_SELECTOR);
    if (button) return button;

    const gridItem = card.closest('.grid__item');
    if (gridItem) {
      return gridItem.querySelector(STOCK_ALERT_SELECTOR);
    }

    return null;
  }

  function placeCardStockAlertButton(card) {
    const button = findCardStockAlertButton(card);
    if (!button) return;

    const slot =
      card.querySelector('.card__price-row__quick-add') ||
      card.querySelector('.card__price-row--inline-quick-add') ||
      card.querySelector('.card__price-row');
    if (!slot) return;

    hideSoldOutQuickAdd(slot);
    hideSpinners(slot);

    if (!slot.contains(button)) {
      slot.appendChild(button);
    }

    styleStockAlertButton(button);
  }

  function findProductStockAlertButtons(root = document) {
    const found = new Set();

    root.querySelectorAll(PRODUCT_ROOT_SELECTOR).forEach((container) => {
      container.querySelectorAll(STOCK_ALERT_SELECTOR).forEach((button) => {
        if (isStockAlertButton(button)) found.add(button);
      });
      container.querySelectorAll('button, a[href], [role="button"]').forEach((button) => {
        if (isStockAlertByText(button)) found.add(button);
      });
    });

    if (document.body.classList.contains('template-product')) {
      root.querySelectorAll(STOCK_ALERT_SELECTOR).forEach((button) => {
        if (!button.closest('.card-wrapper--product') && isStockAlertButton(button)) found.add(button);
      });
      root.querySelectorAll('button, a[href], [role="button"]').forEach((button) => {
        if (!button.closest('.card-wrapper--product') && isStockAlertByText(button)) found.add(button);
      });
    }

    return [...found];
  }

  function styleProductStockAlertButtons(root = document) {
    findProductStockAlertButtons(root).forEach(placeProductStockAlertButton);
  }

  function hideSpecialOrderAlerts(root) {
    root.querySelectorAll('[data-special-order]').forEach((host) => {
      host.querySelectorAll(`${STOCK_ALERT_SELECTOR}, .stock-alert-button-loading, .${PLACED_CLASS}, .${UNIT_CLASS}`).forEach((button) => {
        button.hidden = true;
        button.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function processCards(root = document) {
    hideSpecialOrderAlerts(root);
    root.querySelectorAll('.card-wrapper--product').forEach((card) => {
      if (card.dataset.specialOrder === 'true') {
        hideSpinners(card);
        return;
      }
      const slot = card.querySelector('.card__price-row__quick-add, .card__price-row--inline-quick-add, .card__price-row');
      if (slot) hideSoldOutQuickAdd(slot);
      placeCardStockAlertButton(card);
      ensureCardSpinner(card);
    });
  }

  function processAll(root = document) {
    syncProductRows(root);
    processCards(root);
    styleProductStockAlertButtons(root);
    ensureProductPageSpinner(root);
  }

  function handleAddedNode(node) {
    if (!(node instanceof Element)) return;
    if (node.closest(REZ_MODAL_SELECTOR)) return;

    if (isStockAlertButton(node) || isStockAlertByText(node)) {
      const card = node.closest('.card-wrapper--product');
      if (card) {
        placeCardStockAlertButton(card);
      } else if (node.closest(PRODUCT_ROOT_SELECTOR)) {
        placeProductStockAlertButton(node);
      }
      return;
    }

    if (node.matches('.card-wrapper--product')) {
      placeCardStockAlertButton(node);
      ensureCardSpinner(node);
      return;
    }

    if (node.matches(PRODUCT_ROOT_SELECTOR)) {
      styleProductStockAlertButtons(node);
      ensureProductPageSpinner(node);
      return;
    }

    processAll(node);
  }

  function init() {
    processAll();
    scheduleRezCollectionProcess();

    let retries = 0;
    const retryTimer = window.setInterval(() => {
      processAll();
      retries += 1;
      if (retries >= 30) {
        window.clearInterval(retryTimer);
        document.querySelectorAll(SPINNER_SELECTOR).forEach((spinner) => spinner.remove());
      }
    }, 500);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(handleAddedNode);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    processAll(event.target);
    scheduleRezCollectionProcess();
  });
  document.addEventListener('product-grid:updated', (event) => {
    processAll(event.detail?.container || document);
    scheduleRezCollectionProcess();
  });

  function specialOrderMap(sectionId) {
    const direct = document.getElementById(`SpecialOrderVariants-${sectionId}`);
    if (direct) {
      try {
        return JSON.parse(direct.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    const root = document.querySelector(`product-info[data-section="${sectionId}"]`);
    const originalId = root?.dataset.originalSection;
    if (!originalId) return {};
    const fallback = document.getElementById(`SpecialOrderVariants-${originalId}`);
    if (!fallback) return {};
    try {
      return JSON.parse(fallback.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function syncSpecialOrder(sectionId, variant) {
    if (!sectionId) return;
    const map = specialOrderMap(sectionId);
    const url = variant && map[String(variant.id)] ? map[String(variant.id)] : '';
    const source = document.querySelector(`product-info[data-section="${sectionId}"]`);
    const mainId = source?.dataset.originalSection || sectionId;
    const roots = document.querySelectorAll(
      `product-info[data-section="${mainId}"], product-info[data-original-section="${mainId}"]`
    );

    roots.forEach((root) => {
      if (url) root.setAttribute('data-special-order', 'true');
      else root.removeAttribute('data-special-order');

      root.querySelectorAll('[data-special-order-button]').forEach((button) => {
        button.hidden = !url;
        if (url) button.href = url;
      });
    });

    hideSpecialOrderAlerts(document);
    syncProductRows(document);
    ensureProductPageSpinner(document);
  }

  document.addEventListener('afterVariantChanged', (event) => {
    syncSpecialOrder(event.detail?.sectionId, event.detail?.variant);
    syncProductRows(document);
    styleProductStockAlertButtons(document);
    ensureProductPageSpinner(document);
  });
})();
